<template>
    <ul v-show="visible" class="pt-select-group__wrap">
        <li class="pt-select-group__title">{{ label }}</li>
        <li>
            <ul class="pt-select-group">
                <slot></slot>
            </ul>
        </li>
    </ul>
</template>

<script lang="ts">
export default {
    name: 'PtOptionGroup',
};
</script>

<script setup lang="ts">
import { defineComponent, provide, inject, ref, reactive, toRefs, getCurrentInstance, onMounted } from 'vue';
import { selectGroupKey, selectKey, selectEvents } from './token';

interface Props {
    label: string;
    disabled?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
    disabled: false,
});
const visible = ref(true);
const instance = getCurrentInstance();
const children = ref([]);

provide(
    selectGroupKey,
    reactive({
        ...toRefs(props),
    }),
);

const select = inject(selectKey);

onMounted(() => {
    children.value = flattedChildren(instance?.subTree);
});

// get all instances of options
const flattedChildren = (node) => {
    const children = [];
    if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
            if (child.type && child.type.name === 'PtOption' && child.component && child.component.proxy) {
                children.push(child.component.proxy);
            } else if (child.children?.length) {
                children.push(...flattedChildren(child));
            }
        });
    }
    return children;
};

const queryChange = () => {
    visible.value = children.value.some((option) => option.visible === true);
};
select.selectEmitter.on(selectEvents.groupQueryChange, queryChange);
</script>

<style lang="scss" src="../style/option-group.scss"></style>
